import {
  Alert,
  AngleLeft,
  ChakraBox,
  ChakraButton,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

const { neutral } = EquipUIFireflyV2Theme.colors;
const { labelBold } = EquipUITheme.typography;

type HeaderSectionProps = {
  isEditing: boolean;
  isNonEditable: boolean;
  onBackClick: () => void;
  onVoidClick: () => void;
};

const HeaderSection = ({
  isEditing,
  isNonEditable,
  onBackClick,
  onVoidClick,
}: HeaderSectionProps) => (
  <ChakraBox
    alignItems="center"
    display="flex"
    justifyContent="space-between"
    marginBottom="16px"
  >
    <ChakraButton
      {...labelBold}
      color="neutral.secondary"
      display="flex"
      leftIcon={
        <AngleLeft fill={neutral.secondary} height="15px" width="15px" />
      }
      lineHeight="16.8px"
      onClick={onBackClick}
      variant="link"
    >
      Return to tasks
    </ChakraButton>
    <div>
      {!isNonEditable && (
        <ChakraButton
          {...labelBold}
          background="neutral.background.secondary"
          borderRadius="12px"
          color="neutral.secondary"
          isDisabled={isEditing}
          onClick={onVoidClick}
          padding="13px 12px 12px 12px"
          rightIcon={<Alert />}
          variant="ghost"
        >
          Void / Close
        </ChakraButton>
      )}
    </div>
  </ChakraBox>
);

export default HeaderSection;
